module.exports = {
  space: '',
  cycles: false,
  replacer: (k, v) => v,
  stringify: JSON.stringify
}
